module.exports = __webpack_public_path__ + "img/Smart-LED.3bbc6ead.webp";